import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import style from "./profile.module.scss";
import { Button, Spinner } from "react-bootstrap";
import LoginService from "../../../service/Auth/Login";

function SMSSubscription(props) {
  console.log(props, "sms props");
  const { t } = useTranslation();

  const [loader, setLoader] = useState(false);
  const [isPolicyVisited, setIsPolicyVisited] = useState(false);
  const [subscription, setSubscription] = useState({
    type: props.sms === 1 ? "premium" : "basic", // default to basic or premium based on props
  });

  const subscriptionSubmitHandler = async () => {
    setLoader(true);
    console.log("subscription submit handler");
    const service = new LoginService();
    console.log({ isPolicyVisited });
    if (!isPolicyVisited) {
      setLoader(false);
      return props.showNotify(
        "danger",
        "error",
        "Please Agree To Data Privacy and Policy"
      );
    }
    let res = await service.updateSMSPreference({});
    setLoader(false);
    if (res.status) {
      props.showNotify(
        "success",
        "success",
        res.data?.message ? res.data?.message : "Success"
      );
      setTimeout(function () {
        window.location.reload();
      }, 2000);
    } else {
      return props.showNotify(
        "danger",
        "error",
        res.error?.description
          ? res.error?.description
          : "Some Error Occured. Please Try Again"
      );
    }
  };

  const handlePolicyLinkClick = () => {
    setIsPolicyVisited(true);
    window.open("/privacy-policy", "_blank");
  };

  const handleSubscriptionChange = (type) => {
    if (isPolicyVisited) {
      setSubscription({ type });
    }
  };

  return (
    <div>
      <h2 className={style.modalHeading}>Manage Subscription</h2>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div className="row">
          <div className="col-6">
            <p>BASIC SMS Notification</p>
          </div>
          <input
            type="checkbox"
            checked={subscription.type === "basic"}
            onChange={() => handleSubscriptionChange("basic")}
            disabled={!isPolicyVisited}
            className={style["custom-checkbox"]}
          />
        </div>
        <br />
        <div className="row">
          <div className="col-6">
            <p>Premium SMS Notification</p>
          </div>
          <input
            type="checkbox"
            className={style["custom-checkbox"]}
            checked={subscription.type === "premium"}
            onChange={() => handleSubscriptionChange("premium")}
            disabled={!isPolicyVisited}
          />
        </div>
      </div>
      <br />
      <div>
        <p>
          I agree to the{" "}
          <span
            onClick={handlePolicyLinkClick}
            style={{
              color: "blue",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            Data Privacy and Policy
          </span>
          <br />
          <span style={{ color: "red" }}>
            Please read and click the link before ticking the box.
          </span>
        </p>
        <br />
        <div dangerouslySetInnerHTML={{ __html: props.smsContent }}></div>
      </div>
      <div style={{ display: "flex" }}>
        <Button className={style.closebtn} onClick={props.onClose}>
          <small>{t("Button.close").toUpperCase()}</small>
        </Button>
        <Button
          className={style.submitbtn}
          onClick={subscriptionSubmitHandler}
          disabled={loader}
        >
          <small>
            {loader ? (
              <Spinner animation="border" size="sm" />
            ) : (
              "Apply Changes"
            )}
          </small>
        </Button>
      </div>
    </div>
  );
}

export default SMSSubscription;
